<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile" position="start"
        [class.collapsed]="!isMobile && collapsed" class="custom-sidenav" (touchstart)="onTouchStart($event)"
        (touchend)="onTouchEnd($event)">

        <app-teacher-sidenavbar [collapsed]="collapsed" (toggle)="toggleSidenav()" (routeSelected)="closeSidenav()">
        </app-teacher-sidenavbar>
    </mat-sidenav>

    <mat-sidenav-content [ngStyle]="{ 'margin-left': isMobile ? '0' : (collapsed ? '4.5rem' : '15rem') }">
        <app-top-navbar (triggerSidenav)="toggleSidenav()"></app-top-navbar>
        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>